<template>
    <div class="mt-2">
        <label for="to" class="text-sm font-bold">Forward to</label>
        <tag-input class="bg-white mt-0 border border-gray-dark relative rounded-md shadow-sm w-full outline-none p-2" placeholder="Start typing to see suggestions..." :current="variables.to" @change="addresses => (variables.to = addresses)" :suggestions="queryContacts" />
        
        <!-- <div class="md:flex md:items-center ">
            <div class="md:w-2/12">
                <p class="font-bold rounded p-2">
                    To
                </p>
            </div>
            <div class="md:w-10/12">
                <tag-input class="w-full bg-gray-light border border-gray-dark flex rounded-md shadow-sm p-2 sm:text-sm outline-none font-bold" placeholder="Add email addresses..." :current="variables.to" @change="addresses => (variables.to = addresses)" :suggestions="queryContacts" />
            </div>
        </div> -->

        <label for="body" class="text-sm font-bold">Email Body</label>
        <textarea id="body" v-model="variables.body" rows="4" class="border border-gray-dark relative rounded-md shadow-sm sm:text-sm w-full outline-none p-2" placeholder="What should be sent as reply?"></textarea>

        <!-- <div class="md:flex md:items-center mt-2">
            <div class="md:w-2/12">
                <p class="font-bold rounded p-2">
                    Body
                </p>
            </div>
            <div class="md:w-10/12">
                <textarea ref="body" v-model="variables.body" rows="4" class="w-full bg-gray-light border border-gray-dark flex rounded-md shadow-sm p-2 sm:text-sm outline-none font-bold" placeholder="Start writing here"></textarea>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: 'forward',
            variables: {
                to: [],
                body: '',
            },
        }
    },
    mounted() {
        this.syncData();
    },
    watch: {
        $data: {
            handler() {
                this.syncData();
            },
            deep: true,
        }
    },
    methods: {
        syncData() {
            this.$emit('change', {
                name     : this.name,
                variables: this.variables,
            });
        },
        queryContacts(input, callback) {
            axios.get(`/api/contacts?query=${input}`)
                .then(response => {
                    callback(
                        response.data.data.map(contact => {
                            return contact.email;
                        })
                    );
                })
                .catch(err => console.error);
        },
    }
}
</script>

<style scoped>
.tag-input {
    padding: 0 !important;
}
.ti-input {
    border: 0 !important;
}
</style>